import { useEffect, useState } from 'react'

const getDeviceType = () => {
  const width = window.innerWidth
  if (width < 768) return 'mobile'
  if (width <= 1024) return 'tablet'
  return 'desktop'
}

export const useDeviceType = () => {
  const [device, setDevice] = useState(getDeviceType)

  useEffect(() => {
    const updateDeviceType = () => {
      setDevice(getDeviceType())
    }

    const mediaQuery = window.matchMedia('(max-width: 1024px)')
    mediaQuery.addEventListener('change', updateDeviceType)

    return () => mediaQuery.removeEventListener('change', updateDeviceType)
  }, [])

  return device
}
